
import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/utils/Modal'
import Close from 'images/close.svg'

const MissionBlockEditModalErrorNew = ({
  text,
  onConfirm,
  title,
  above,
  okButton,
  details
}) => (
  <Modal  size='sm' className={`mission-block-container-modal ${above ? 'modal-above' : ''}`}>
    <div className='pictogram-error-modal'>
        <img src={Close} />
        <p style={{fontSize: '24px', color:  '#B42A27', fontWeight: '700'}} className='mission-modal-title-error'>{title}</p>
        <p style={{fontSize: '18px', color: '#3C3738', marginTop: '-1px'}} className='mission-modal-text'>{text}</p>
        {details && <p style={{fontWeight: '400', fontSize: '14px', fontStyle: 'italic', color: '#3C3738'}}>Detalhes: {details}</p>}
        <button style={{backgroundColor: '#41A017'}} onClick={onConfirm}>{okButton}</button>
    </div>

  </Modal>

  )

MissionBlockEditModalErrorNew.propTypes = {
  text: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  okButton: PropTypes.string.isRequired,
  above: PropTypes.bool.isRequired,
  details: PropTypes.string.isRequired
}
export default MissionBlockEditModalErrorNew
